import { RequestService } from '../../../../../common/services/RequestService';
import { FACILITIES_GET } from '../../constants';

export const getFacilitiesRequest = payload => {
  return RequestService.get(FACILITIES_GET);
};
